import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    backgroundColor: neutrals.white,
    paddingBottom: 24,
    rowGap: 24,
    columnGap: 2,
  },
  selected: {
    borderWidth: 2,
    borderRadius: 10,
    borderColor: brand.main.water,
  },
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 15,
    paddingHorizontal: 5,
    paddingTop: 10,
  },
  title: {
    fontSize: 20,
    fontWeight: '700',
    color: neutrals.black,
  },
  optionImage: {
    backgroundColor: neutrals.neutralGrays.snow,
    borderRadius: 10,
    height: 90,
    width: 90,
  },
  optionText: {
    fontSize: 12,
    marginVertical: 4,
  },
  optionPrice: {
    fontSize: 16,
    fontWeight: '700',
    color: neutrals.black,
  },
  container_apply_all: {
    paddingVertical: 16,
    paddingHorizontal: 24,
  },
  icon: {
    color: neutrals.neutralGrays.ash
  },
});
